import { days } from 'config/Vars'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import getDayOfWeekLabel from 'modules/core/lib/getDayOfWeekLabel'
import i18n from 'modules/core/lib/i18n'

import type PersonalForm from 'modules/settings/lib/forms/Personal'

interface Props {
  personalForm: PersonalForm
}

const FirstWeekDaySelector = (props: Props) => {
  const options = days().map((value) => ({
    label: getDayOfWeekLabel(value),
    value,
  }))

  return (
    <Select
      label={i18n.t('personal_settings.first_day_of_week')}
      options={options}
      field={props.personalForm.get('first_day_of_week')}
    />
  )
}

export default observer(FirstWeekDaySelector)
